import { render, staticRenderFns } from "./movement-classification-modal.vue?vue&type=template&id=e95eeb98&"
import script from "./movement-classification-modal.vue?vue&type=script&lang=js&"
export * from "./movement-classification-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports